// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"139":"category","187":"search","536":"game-records","747":"ranking"}[chunkId] + "." + {"139":"7f3a0ad6","187":"5653bae0","536":"be08b163","747":"2ae032c3"}[chunkId] + ".css";
};